import { useMediaQuery } from "@vueuse/core";

export function useIsSmallScreen() {
  const isSmallScreen = useMediaQuery("(max-width: 639px)");

  return { isSmallScreen };
}
